<!-- 组件名：Contact.vue | 路由路径：/contact/ -->
<template>
  <div class="page-wrap">
    <FmNavBar />
    <div class="container">
      <header class="hero"><h1>Contact Us</h1><p>Need help with installation, updates, or policy questions? Reach out through the channels below.</p></header>
      <section class="section"><h2>Support Email</h2><p>Email: support@fmwhatsap.net</p><p>Response window: usually within 24-72 hours.</p></section>
      <section class="section"><h2>Business Inquiries</h2><p>Email: business@fmwhatsap.net</p><p>Use this contact for partnership, licensing, and media requests.</p></section>
      <section class="section"><h2>Before You Contact</h2><ul><li>Include your Android version and device model.</li><li>Mention current app version and exact error message.</li><li>Attach screenshots when possible for faster support.</li></ul></section>
    </div>
  </div>
</template>
<script>
import FmNavBar from '@/components/FmNavBar.vue'
export default { name: 'Contact', components: { FmNavBar } }
</script>
<style scoped>
.page-wrap{background:#f5f5f5;min-height:100vh}.container{max-width:1100px;margin:0 auto;padding:20px}.hero{background:#075e54;color:#fff;padding:28px 20px;border-radius:12px;margin-bottom:24px}.hero h1{margin:0 0 10px;font-size:32px}.hero p{margin:0;font-size:17px}.section{background:#fff;border-radius:12px;padding:24px;margin-bottom:18px;box-shadow:0 2px 8px rgba(0,0,0,.06)}.section h2{color:#075e54;margin:0 0 12px;border-left:4px solid #25d366;padding-left:10px}.section ul{margin:0;padding-left:22px}.section li{margin-bottom:9px}@media (max-width:768px){.hero h1{font-size:25px}.section{padding:16px}}
</style>
